import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';

export const Close = ({ children }: React.PropsWithChildren) => {
  return <Dialog.Close asChild>{children}</Dialog.Close>;
};

export default Close;
